module.exports = __webpack_public_path__ + "static/pid-ug-14-en-authcode-2510a0ee05aaa0d56fe8868996eb9020.png";